"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Bolt = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Bolt = function Bolt(_a) {
  var id = _a.id;
  var clipPathId = id ? "Bolt__clip0__".concat(id) : 'Bolt__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.744.201a1.475 1.475 0 00-1.488 0l-9 5.243A1.534 1.534 0 001.5 6.77V17.23c0 .548.288 1.055.756 1.327l9 5.242a1.475 1.475 0 001.488 0l9-5.242c.468-.272.756-.779.756-1.327V6.77c0-.548-.288-1.055-.756-1.327l-9-5.243zM12 18a6 6 0 100-12 6 6 0 000 12z",
    clipRule: "evenodd"
  }), react_1.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3",
    opacity: "0.72"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Bolt = Bolt;